import { render, staticRenderFns } from "./DonationSettingsModal.vue?vue&type=template&id=4848f796&"
import script from "./DonationSettingsModal.vue?vue&type=script&lang=js&"
export * from "./DonationSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports